'use client'

const Home = () => {
  return <h1 className="font-space-grotesk text-light-500 text-3xl">Welcome to Lobek Directory</h1>
}

export default Home
